import { Carousel } from 'antd';
import React, { useState } from 'react';
import growthImg from '../../../../../assets/images/deals/growth.png';
import incomeImg from '../../../../../assets/images/deals/income.png';
import useIntervalTransition from '../../../../../hooks/useIntervalTransition';

export const common_container = 'max-w-[1600px] m-auto px-4 md:px-6 lg:px-16 xl:px-20 2xl:px-24';

const sliderData: { title: string; description: string }[] = [
    {
        title: 'INCOME',
        description: 'Generate income through recurring distribution payments',
    },
    {
        title: 'GROWTH',
        description: 'Invest in the most innovative firms in the region',
    },
];
const headingClass = 'font-[WorkSans] font-semibold text-2xl lg:text-3xl text-white';
const valueClass = 'text-white font-[WorkSans] text-[11px] mr-2 w-fit';

const DealsTopCard: React.FC = () => {
    const [active, setActive] = useState(0);

    const transitions = {
        million: useIntervalTransition(500, 100),
        countryInvestment: useIntervalTransition(9, 100),
        minimumPercentage: useIntervalTransition(9, 100),
        maximumPercentage: useIntervalTransition(13, 100),
    };
    const onChange = (currentSlide: number) => {
        setActive(currentSlide);
    };

    return (
        <div className="bg-[#142C53]">
            <div
                className={`max-w-[1600px] m-auto pl-4 md:pl-6 lg:pl-16 xl:pl-20 2xl:pl-24 md:pr-0 md:pb-0 pb-8  pr-4 flex flex-wrap`}
            >
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
                    <div className=" col-span-1 py-8 w-full lg:w-[200%]">
                        <p className="font-[WorkSans-Semibold] text-white font-semibold text-[22px] lg:text-[32px] uppercase">
                            Invest in what <span className="text-[#41D17E]">matters</span> to you
                        </p>
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-2 pt-4">
                            <div>
                                <p>
                                    <span className={headingClass}>{transitions.million}+</span>
                                    <span className="text-[11px] text-white font-[WorkSans] ml-1">Million</span>
                                </p>

                                <div className={valueClass}>
                                    <p className="h-[1px] bg-[#476CA7] opacity-40 w-auto my-1"></p>
                                    Investment Volume Deployed (USD)
                                </div>
                            </div>
                            <div>
                                <p>
                                    <span className={headingClass}>{transitions.countryInvestment}</span>
                                </p>
                                <div className={valueClass}>
                                    <p className="h-[1px] bg-[#476CA7] opacity-40 w-auto my-1"></p>
                                    Countries with Investments
                                </div>
                            </div>
                            <div>
                                <p>
                                    <span className={headingClass}>
                                        {transitions.minimumPercentage}-{transitions.maximumPercentage}%
                                    </span>
                                </p>
                                <div className={valueClass}>
                                    <p className="h-[1px] bg-[#476CA7] opacity-40 w-auto my-1"></p>
                                    Historical Returns
                                </div>
                            </div>
                            <div>
                                <p>
                                    <span className={headingClass}>0</span>
                                </p>
                                <div className={valueClass}>
                                    <p className="h-[1px] bg-[#476CA7] opacity-40 w-auto my-1"></p>
                                    Defaults
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1 w-0 lg:block hidden"></div>
                    <div className="relative w-full col-span-1 bg-white">
                        <div
                            className={
                                'dealTopCard  px-2 py-2 w-full mb-4 md:mb-0 mt-8 md:mt-0  bg-cover bg-no-repeat border border-transparent md:absolute top-0 bottom-0'
                            }
                            style={{ backgroundImage: `url(${active === 0 ? incomeImg : growthImg})` }}
                        >
                            <Carousel dotPosition="bottom" dots autoplay afterChange={onChange} speed={1000}>
                                {sliderData.map((s) => (
                                    <div key={`${s.title}`} className="px-4 pb-2 pr-2 h-full">
                                        <p className="mb-5 font-[WorkSans-Semibold] font-semibold text-[22px]  lg:text-3xl text-[#132A51]">
                                            {s.title}
                                        </p>
                                        <p className="text-[#132A51] text-base lg:text-xl font-[WorkSans] font-medium mb-4">
                                            {s.description}
                                        </p>
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DealsTopCard;
